/* Share concurrent offer reads; Shopify cart/checkout remain authoritative. */
(() => {
  let pending;
  let recent;
  let updated = 0;
  window.NiralaDiscountData = {
    read() {
      if (!window.NiralaRemoteDiscountsEnabled) return Promise.resolve({schemaVersion:1,campaigns:[]});
      if (pending) return pending;
      if (recent && Date.now() - updated < 1000) return Promise.resolve(recent);
      pending = fetch('/apps/nirala-discounts', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000) })
        .then(response => { if (!response.ok) throw new Error('Offers unavailable'); return response.json(); })
        .then(data => {
          if (data.schemaVersion !== 1 || !Array.isArray(data.campaigns)) throw new Error('Invalid offers');
          recent = data; updated = Date.now(); return data;
        }).finally(() => { pending = null; });
      return pending;
    }
  };
})();
